class HeroDropdown {

  constructor() {
    this.buttonListener()
  }

  buttonListener() {
    addEventListener('click', (ev) => {
      if (ev.target.classList.contains("hero-dropdown__link")) return // ignore link clicks
      if (ev.target.classList.contains('hero-dropdown__button')) {
        const dropdown = ev.target.closest('.hero-dropdown')
        if (dropdown.classList.contains("hero-dropdown--open")) {
          this.closeDropdown(dropdown)
        } else if (!dropdown.classList.contains("hero-dropdown--open")) {
          this.openDropdown(dropdown)
        }
      } else {
        const dropdowns = document.querySelectorAll('.hero-dropdown')
        dropdowns.forEach(dropdown => {
          this.closeDropdown(dropdown)
        })
      }
    })
  }

  closeDropdown(dropdown) {
    dropdown.classList.remove('hero-dropdown--open')
    const list = dropdown.querySelector('.hero-dropdown__list-container')
    list.setAttribute('inert', '')
  }

  openDropdown(dropdown) {
    dropdown.classList.add('hero-dropdown--open')
    const list = dropdown.querySelector('.hero-dropdown__list-container')
    list.removeAttribute('inert')
  }

}

export default HeroDropdown